import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './Spacer.css';

const Spacer = ({ size, media, text }) => {
  const classId = ['spacer', media, size].filter(i => !!i).join('-');

  const className = classnames(styles.spacer, styles[classId]);

  if (!text) {
    return <div className={className} />;
  }

  return (
    <div className={classnames(className, styles.textSeparator)}>
      <span className={styles.line} />
      <span className={styles.text}>{text}</span>
    </div>
  );
};

Spacer.defaultProps = {
  size: 8,
  media: null,
  text: null,
};

Spacer.propTypes = {
  text: PropTypes.object,
  size: PropTypes.oneOf([1, 2, 4, 6, 8, 12, 16, 32]),
  media: PropTypes.oneOf([null, 'tablet']),
};

export default Spacer;
